<template>
  <section class="" style="background: #F6F6F6;color:black">
    <div class="bg-grey" >
      <h2 class="section-title page-title h2 text-center text-black f-44 h2-caslon" >Commodity Plastics</h2>
    </div>
  </section>
  <section class="section-product-detail-page bg-primary">
    <div class="container">
      <div class="page-content">
        <div class="content">

          <ContentsTextWithImage
            title="Commodity Plastics"
            image-url="/pages/products/commodity-plastics/commm.jpg"
            :contents="[
              'Commodity plastics are the most used plastics in the world. They are used for plastic bag, food and consumer product packaging, household or single used application such as PP, PE, PS, POM, ABS',
            ]"
            :is-content-small-text="true"
            is-white-content="true"
            left-width="39.821%"
            right-width="60.179%"
          />

        </div>
      </div>
    </div>
  </section>

  <!-- PAGE CONTAINER -->
  <section class="section-product bg-grey">
    <div class="container page-container">
      <div class="row m-0">
        <div class="col-12 gallery-container">

          <div class="row m-0">
            <div class="col-12 col-md-6 p-0">
              <!-- CARD IMAGE -->
              <div class="card-image">
                <div class="image-wrapper">
                  <a href="/th/plastics/products/commodity-plastics/abs-2">
                    <img src="/pages/products/commodity-plastics/re01.jpg" alt="ABS (Acrylonitrile Butadiene Styrene)">
                  </a>
                </div>
                <div class="card-content">
                  <a href="/th/plastics/products/commodity-plastics/abs-2" class="card-title f-21">ABS (Acrylonitrile Butadiene Styrene)</a>
                </div>
              </div>
              <!-- CARD IMAGE -->
            </div>
            <div class="col-12 col-md-6 p-0">
              <!-- CARD IMAGE -->
              <div class="card-image">
                <div class="image-wrapper">
                  <a href="/th/plastics/products/commodity-plastics/hips-2">
                    <img src="/pages/products/commodity-plastics/re02.jpg" alt="HIPS (Hi impact Polystyrene)">
                  </a>
                </div>
                <div class="card-content">
                  <a href="/th/plastics/products/commodity-plastics/hips-2"  class="card-title f-21">HIPS (Hi impact Polystyrene)</a>
                </div>
              </div>
              <!-- CARD IMAGE -->
            </div>
          </div>
  
          <div class="row m-0" style="padding-top: 10px">
            <div class="col-12 col-md-6 p-0">
              <!-- CARD IMAGE -->
              <div class="card-image">
                <div class="image-wrapper">
                  <a href="/th/plastics/products/commodity-plastics/pp-2">
                    <img src="/pages/products/commodity-plastics/re03.jpg" alt="PP (Polypropylene)">
                  </a>
                </div>
                <div class="card-content">
                  <a href="/th/plastics/products/commodity-plastics/pp-2" class="card-title f-21">PP (Polypropylene )</a>
                </div>
              </div>
              <!-- CARD IMAGE -->
            </div>
            <div class="col-12 col-md-6 p-0">
              <!-- CARD IMAGE -->
              <div class="card-image">
                <div class="image-wrapper">
                  <a href="/th/plastics/products/commodity-plastics/pom-2">
                    <img src="/pages/products/commodity-plastics/re04.jpg" alt="POM (Polyoxymethylene or Acetal)">
                  </a>
                </div>
                <div class="card-content">
                  <a href="/th/plastics/products/commodity-plastics/pom-2" class="card-title f-21">POM (Polyoxymethylene or Acetal)</a>
                </div>
              </div>
              <!-- CARD IMAGE -->
            </div>
          </div>

        </div>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
useHead({
  title:'Commodity Plastics - NAGASE THAILAND Engineering Plastics',
  meta: [
    {
      rel: 'alternate',
      hreflang: 'en',
      href: `https://group.nagase.com/th/plastics/${process.env.VITE_LANG}/products/commodity-plastics`,
    }
  ]
})
</script>

<style scoped>
.card-image .image-wrapper {
  aspect-ratio: 773 / 438;
}

.section-product {
  padding: 60px 0;
}


</style>